import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { reduxForm } from "redux-form";
import Filters from "../../Utils/Filters/Filters";
import Grid from "../../Utils/Grid";

import "./report-detailed-emergency.css";

const List = ({
    listarReport,
    data,
    loader,
    listar,
    descargarExcel,
    start_date,
    setStartDate,
    end_date,
    setEndDate,
    emergency_type_id,
    setTypeEmergency,
    station,
    setStation,
    region,
    setRegion,
    emergency_type_category,
    setTypeEmergencyCategory,
    me,
    excelLoading,
    excelProgress,
}) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('1');
    const [currentPage, setCurrentPage] = React.useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        listarReport();
    }, []);

    if (!me.station) {
        NotificationManager.error('No tienes una estación asignada', 'Error', 3000);
    }

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            setCurrentPage(1);
        }
    }

    const renderPagination = (currentPage, totalPages, setCurrentPage) => {
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, currentPage + 2);

        if (endPage - startPage < 4) {
            if (startPage === 1) {
                endPage = Math.min(totalPages, 5);
            } else if (endPage === totalPages) {
                startPage = Math.max(1, totalPages - 4);
            }
        }

        const pages = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return (
            <ul className="pagination pagination-sm mb-0 flex-wrap justify-content-center custom-pagination-chips">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(1)}>Primero</button>
                </li>
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>Anterior</button>
                </li>
                {pages.map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>Siguiente</button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(totalPages)}>Último</button>
                </li>
            </ul>
        );
    };

    // Helper functions for Data 1 & 2
    const renderCountTable = (dataList) => {
        if (!dataList || dataList.length === 0) return <div className="p-3 text-center text-muted border border-top-0 bg-white">No hay datos disponibles para los filtros seleccionados.</div>;

        // Calculate Grand Totals — mirror the duplication-per-station logic of other reports:
        // A cross-station emergency is counted once per region it was attended in.
        let gCentral = 0, gSur = 0, gOriente = 0, gOccidente = 0, gNorte = 0, gTotal = 0;
        dataList.forEach(item => {
            gCentral += item.region_central || 0;
            gSur += item.region_sur || 0;
            gOriente += item.region_oriente || 0;
            gOccidente += item.region_occidente || 0;
            gNorte += item.region_norte || 0;
            // Use per-region sum (total_region) to stay coherent with regional/general reports
            gTotal += item.total_region || 0;
        });

        const totalItems = dataList.length;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const paginatedData = dataList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

        return (
            <React.Fragment>
                <div className="table-responsive bg-white border border-top-0" style={{ borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                    <table className="table table-hover mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th className="font-weight-bold" style={{ width: "80px" }}>Código</th>
                                <th className="font-weight-bold" style={{ minWidth: "300px" }}>Tipo de Emergencia</th>
                                <th className="font-weight-bold text-center">Central</th>
                                <th className="font-weight-bold text-center">Sur</th>
                                <th className="font-weight-bold text-center">Oriente</th>
                                <th className="font-weight-bold text-center">Occidente</th>
                                <th className="font-weight-bold text-center">Norte</th>
                                <th className="font-weight-bold text-center bg-light">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => (
                                <tr key={index}>
                                    <td className="align-middle text-muted">{item['emergency__emergency_type__id']}</td>
                                    <td className="align-middle">{item['emergency__emergency_type__name'] || item.name_all || '—'}</td>
                                    <td className="align-middle text-center">{item.region_central}</td>
                                    <td className="align-middle text-center">{item.region_sur}</td>
                                    <td className="align-middle text-center">{item.region_oriente}</td>
                                    <td className="align-middle text-center">{item.region_occidente}</td>
                                    <td className="align-middle text-center">{item.region_norte}</td>
                                    <td className="align-middle text-center font-weight-bold bg-light">
                                        {item.total_region || 0}
                                    </td>
                                </tr>
                            ))}
                            {/* Grand Total Row */}
                            <tr className="bg-light font-weight-bold sticky-total-row-detailed">
                                <td colSpan="2" className="text-right border-top-2 border-dark">GRAN TOTAL</td>
                                <td className="text-center border-top-2 border-dark">{gCentral}</td>
                                <td className="text-center border-top-2 border-dark">{gSur}</td>
                                <td className="text-center border-top-2 border-dark">{gOriente}</td>
                                <td className="text-center border-top-2 border-dark">{gOccidente}</td>
                                <td className="text-center border-top-2 border-dark">{gNorte}</td>
                                <td className="text-center border-top-2 border-dark text-primary">{(data && data.grand_total_unique !== undefined) ? data.grand_total_unique : gTotal}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center justify-content-md-end p-3 bg-white shadow-sm sticky-pagination" style={{ borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                        <nav>
                            {renderPagination(currentPage, totalPages, setCurrentPage)}
                        </nav>
                    </div>
                )}
            </React.Fragment>
        );
    };

    // Helper functions for Data 3
    const renderStationTable = (dataList) => {
        if (!dataList || dataList.length === 0) return <div className="p-3 text-center text-muted border border-top-0 bg-white">No hay datos disponibles para los filtros seleccionados.</div>;

        // Grouping Data
        // Hierarchy: Station -> Category -> Type
        const grouped = {};
        let grandTotal = 0;

        dataList.forEach(item => {
            const temp_station_no = item.station_emergency__station__no_station;
            const temp_station_name = item.station_emergency__station__name;
            const stationKey = (temp_station_no && String(temp_station_no) !== "0")
                ? `${temp_station_no} - ${temp_station_name}`
                : temp_station_name;

            const categoryKey = item.category_group || "Sin Categoria";

            if (!grouped[stationKey]) grouped[stationKey] = { total: 0, categories: {} };
            if (!grouped[stationKey].categories[categoryKey]) grouped[stationKey].categories[categoryKey] = { total: 0, items: [] };

            grouped[stationKey].categories[categoryKey].items.push(item);

            const count = item.total_emergency_attend || 0;
            grouped[stationKey].categories[categoryKey].total += count;
            grouped[stationKey].total += count;
            grandTotal += count;
        });

        const groupedEntries = Object.entries(grouped);
        const totalItems = groupedEntries.length;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const paginatedEntries = groupedEntries.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

        return (
            <React.Fragment>
                <div className="table-responsive bg-white border border-top-0" style={{ borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                    <table className="table mb-0">
                        <tbody>
                            {paginatedEntries.map(([stationName, stationData], sIdx) => (
                                <React.Fragment key={`station-${sIdx}`}>
                                    {/* Station Header */}
                                    <tr>
                                        <td colSpan="4" className="text-center font-weight-bold text-white align-middle" style={{ backgroundColor: '#0f45c7', fontSize: '1.2rem', padding: '12px' }}>
                                            {stationName}
                                        </td>
                                    </tr>
                                    <tr className="thead-light">
                                        <th className="font-weight-bold" style={{ width: "100px" }}>Código</th>
                                        <th className="font-weight-bold">Tipo de Emergencia</th>
                                        <th className="font-weight-bold text-center" style={{ width: "150px" }}>CANTIDAD</th>
                                        <th className="font-weight-bold text-center" style={{ width: "150px" }}>TOTAL</th>
                                    </tr>

                                    {/* Categories */}
                                    {Object.entries(stationData.categories).map(([categoryName, categoryData], cIdx) => (
                                        <React.Fragment key={`cat-${sIdx}-${cIdx}`}>
                                            <tr>
                                                <td colSpan="4" className="font-weight-bold align-middle bg-light" style={{ color: '#C70F0F', fontSize: '1.1rem' }}>
                                                    {categoryName}
                                                </td>
                                            </tr>
                                            {categoryData.items.map((item, iIdx) => (
                                                <tr key={`item-${sIdx}-${cIdx}-${iIdx}`}>
                                                    <td className="align-middle text-muted">{item.emergency_type__code}</td>
                                                    <td className="align-middle">{item.emergency_type__name || item.name_emergency}</td>
                                                    <td className="align-middle text-center">{item.total_emergency_attend || 0}</td>
                                                    {/* Category Total span logic. We simulate Excel by putting the Subtotal in the first row of the category and rowspan it. For HTML ease, we can just put it in a separate row or rowspan. Let's rowspan. */}
                                                    {iIdx === 0 && (
                                                        <td rowSpan={categoryData.items.length} className="align-middle text-center font-weight-bold border-left">
                                                            {categoryData.total}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}

                                    {/* Station Total */}
                                    <tr className="bg-light font-weight-bold">
                                        <td colSpan="2" className="text-right border-top border-dark text-muted">Total Estación</td>
                                        <td className="text-center border-top border-dark text-primary">{stationData.total}</td>
                                        <td className="border-top border-dark border-left"></td>
                                    </tr>
                                </React.Fragment>
                            ))}

                            {/* Grand Total */}
                            <tr className="bg-white">
                                <td colSpan="4" style={{ height: "20px", border: "none" }}></td>
                            </tr>
                            <tr className="sticky-total-row-detailed">
                                <td colSpan="2"></td>
                                <td className="font-weight-bold text-right align-middle" style={{ fontSize: '1.1rem' }}>GRAN TOTAL</td>
                                <td className="font-weight-bold text-center align-middle text-white" style={{ backgroundColor: '#0f45c7', fontSize: '1.2rem' }}>
                                    {(data && data.grand_total_unique !== undefined) ? data.grand_total_unique : grandTotal}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center justify-content-md-end p-3 bg-white shadow-sm sticky-pagination" style={{ borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                        <nav>
                            {renderPagination(currentPage, totalPages, setCurrentPage)}
                        </nav>
                    </div>
                )}
            </React.Fragment>
        );
    };

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                        <div>
                            <h2 className="font-weight-bold" style={{ color: "#1E2A41", fontSize: "1.75rem", margin: 0 }}>Reporte Detallado de Emergencias</h2>
                            <h6 className="text-muted" style={{ fontWeight: 500, margin: 0 }}>Análisis Estadístico Avanzado</h6>
                        </div>
                    </div>
                    <div className="mb-4 card card-report-detailed-emergency shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="mb-0 px-3 pt-3">
                            <div className="filters-container-rrhh mb-4">
                                <div className="filters-fields-group">
                                    <Filters
                                        startDate={{
                                            show: true,
                                            start_date: start_date,
                                            setStartDate: setStartDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        endDate={{
                                            show: true,
                                            end_date: end_date,
                                            setEndDate: setEndDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        emergency_type_category={{
                                            show: true,
                                            multi: true,
                                            disabled: emergency_type_id && emergency_type_id.length !== 0 ? true : false,
                                            emergency_type: emergency_type_category,
                                            nameApiOptions: 'category_emergency_type',
                                            setTypeEmergency: setTypeEmergencyCategory,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "filter_list",
                                        }}
                                        emergency_type={{
                                            show: true,
                                            multi: true,
                                            disabled: emergency_type_category && (emergency_type_category).length !== 0,
                                            emergency_type: emergency_type_id,
                                            setTypeEmergency: setTypeEmergency,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "filter_list",
                                        }}
                                        station={{
                                            show: me.role === 5 ? false : true,
                                            station: station,
                                            setStation: setStation,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "business",
                                        }}
                                        region={{
                                            show: true,
                                            region: region,
                                            filterByRegion: setRegion,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "public",
                                        }}
                                    />
                                </div>
                                <div className="filters-actions-group">
                                    <button
                                        className="btn font-weight-bold d-flex align-items-center outline-none"
                                        style={{ backgroundColor: "#e0e7ff", color: "#3b82f6", borderRadius: "30px", padding: "10px 24px", transition: "all 0.2s", fontSize: "14px", border: "none" }}
                                        onClick={descargarExcel}
                                        disabled={excelLoading || !me.station}
                                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#c7d2fe"; }}
                                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#e0e7ff"; }}
                                    >
                                        {excelLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <span className="material-icons" style={{ fontSize: "18px", color: "#3b82f6" }}>insert_drive_file</span>
                                        )}
                                        <span className="ml-2">{excelLoading ? 'Generando Excel...' : 'Exportar Excel'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="p-0 px-3 pt-0 pb-4">
                            {loader ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Cargando datos del reporte...</p>
                                </div>
                            ) : (
                                <div className="mx-3 mt-2">
                                    <ul className="nav nav-tabs nav-tabs-custom" style={{ borderBottom: '2px solid #e2e8f0', marginBottom: '0' }}>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link font-weight-bold px-4 py-3 ${activeTab === '1' ? 'active' : ''}`}
                                                style={{
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    borderBottom: activeTab === '1' ? '3px solid #3b82f6' : '3px solid transparent',
                                                    color: activeTab === '1' ? '#3b82f6' : '#64748b',
                                                    backgroundColor: 'transparent'
                                                }}
                                                onClick={() => toggleTab('1')}
                                            >
                                                <i className="material-icons align-middle mr-2" style={{ fontSize: '18px' }}>local_fire_department</i>
                                                Reporte de Emergencias
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link font-weight-bold px-4 py-3 ${activeTab === '2' ? 'active' : ''}`}
                                                style={{
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    borderBottom: activeTab === '2' ? '3px solid #3b82f6' : '3px solid transparent',
                                                    color: activeTab === '2' ? '#3b82f6' : '#64748b',
                                                    backgroundColor: 'transparent'
                                                }}
                                                onClick={() => toggleTab('2')}
                                            >
                                                <i className="material-icons align-middle mr-2" style={{ fontSize: '18px' }}>personal_injury</i>
                                                Reporte de Pacientes
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link font-weight-bold px-4 py-3 ${activeTab === '3' ? 'active' : ''}`}
                                                style={{
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    borderBottom: activeTab === '3' ? '3px solid #3b82f6' : '3px solid transparent',
                                                    color: activeTab === '3' ? '#3b82f6' : '#64748b',
                                                    backgroundColor: 'transparent'
                                                }}
                                                onClick={() => toggleTab('3')}
                                            >
                                                <i className="material-icons align-middle mr-2" style={{ fontSize: '18px' }}>list_alt</i>
                                                Servicios Cubiertos
                                            </a>
                                        </li>
                                    </ul>

                                    <div className="tab-content" style={{ minHeight: '300px' }}>
                                        {activeTab === '1' && (
                                            <div className="tab-pane fade show active fade-in-up">
                                                {renderCountTable(data && data.data_1)}
                                            </div>
                                        )}
                                        {activeTab === '2' && (
                                            <div className="tab-pane fade show active fade-in-up">
                                                {renderCountTable(data && data.data_2)}
                                            </div>
                                        )}
                                        {activeTab === '3' && (
                                            <div className="tab-pane fade show active fade-in-up">
                                                {renderStationTable(data && data.data_3)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reduxForm({
    form: "ListReportEmergenciesDetailS",
})(List);
